/**
 * Wire-form contact attribute placeholder.
 *
 * The message body stores attribute placeholders as structured Slate nodes and
 * composer-backend converts them. The deeplink is a plain string that
 * composer-backend forwards verbatim, so the placeholder has to be written in
 * the form message-assignment-service resolves directly:
 * `{{aampe.user_property.<attribute name>|<default>}}`.
 */
export const buildUserAttributePlaceholder = (
    attributeName: string,
    defaultValue: string,
): string => `{{aampe.user_property.${attributeName}|${defaultValue}}}`;

export const insertAtCursor = (
    value: string | null | undefined,
    insertion: string,
    cursorPosition: number | null | undefined,
): string => {
    const base = value ?? '';
    if (
        cursorPosition === null ||
        cursorPosition === undefined ||
        cursorPosition > base.length
    ) {
        return base + insertion;
    }
    return (
        base.slice(0, cursorPosition) + insertion + base.slice(cursorPosition)
    );
};
